module.exports = __webpack_public_path__ + "static/img/IMG_20240629_120637.52625c22.jpg";